import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

type UseBestPracticesFilters = {
  clusterIds?: string[];
  filtersv2?: boolean;
};

const SECURITY_BEST_PRACTICE_FILTERS_QUERY_KEY =
  'security-best-practice-filters';

const getBestPracticesFiltersQueryKey = ({
  clusterIds,
  filtersv2,
}: UseBestPracticesFilters) =>
  [
    SECURITY_BEST_PRACTICE_FILTERS_QUERY_KEY,
    clusterIds ?? null,
    filtersv2,
  ] as const;

const getBestPracticesFiltersQueryOptions = ({
  clusterIds,
  filtersv2 = true,
}: UseBestPracticesFilters) =>
  queryOptions({
    queryKey: getBestPracticesFiltersQueryKey({ clusterIds, filtersv2 }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getBestPracticeFilters({
        clusterIds,
        filtersv2,
      });
      return data;
    },
    enabled: !!clusterIds,
  });

export const useBestPracticesFiltersQuery = (
  params: UseBestPracticesFilters
) => {
  const { data, isLoading, error, refetch } = useQuery(
    getBestPracticesFiltersQueryOptions(params)
  );
  return { filters: data, isLoading, error, refetch };
};
